<template>
     <div class="row my-5">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <img src="@/assets/award-winners/2026-ClaytenKersey.jpg" alt="The 2026 Winner of the Cathy Salter Memorial Scholarship, Clayten Kersey" class="winner mx-auto rounded" width="900" height="1061">
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 p-4">
          <h2 class="fw-bold">Clayten Kersey<br><span class="text-danger">The 2026 Scholarship Winner</span></h2>
          <p class="lead">We are proud to announce this year’s recipient of the Cathy Salter Memorial Scholarship is Clayten Kersey. He will be attending Kent State University in the fall, and will be pursuing a degree in Psychology. Best of luck to Clayten in all his future endeavors.</p>
          <router-link to="/previous-awards" class="btn btn-dark btn-lg px-4 gap-3">Previous Winners</router-link>
        </div>
      </div>
</template>

<script>
export default {
  name: 'CurrentWinner',
  props: {
    image: String,
    name: String,
    year: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .winner{
        display: block;
        margin: auto;
        height: 100%;
        width: 100%;
        max-width: 450px;
        object-fit: cover;
    }
</style>
